<div class="legend-map" ng-if="legendas.length">
  <dl class="dl-horizontal" ng-if="!printMode">
    <div ng-repeat="legenda in legendas" ng-mouseover="emitMouseover(legenda)" ng-mouseout="emitMouseout(legenda)">
      <dt style="background: {{legenda.cor}}">
        <i ng-show="legenda.icon" class="{{legenda.icon}} icon-legend" aria-hidden="true"></i>
      </dt>
      <dd class="legenda">
        <span ng-click="setCultura(legenda)" class="{{legenda.cursor}}">
          {{humanize ? (legenda.descricao | humanize) : legenda.descricao}}
        </span>
      </dd>
    </div>
  </dl>
  <div ng-if="printMode">
    <svg width="100vw" height="100vh">
      <g ng-repeat="legenda in legendas" transform="translate(0, {{ 40 * $index }})">
        <rect x="0" y="0" ry="5" width="30" height="30" fill="{{legenda.cor}}" opacity="0.8" />
        <text x="40" y="20">{{humanize ? (legenda.descricao | humanize) : legenda.descricao}}<text />
      </g>
    </svg>
  </div>
</div>
